/*
  Aura House Trade page (v2, 22 Oct 2026). One script for every aura-trade-* section.
  - Spaces: tabs, hero chips and #hash deep links switch the space in place and retune the hero noun,
    lede, schedule card, why line and the curated scent mix.
  - Package builder (gift-page layout): three fixed packages, each priced both ways on its card.
    Subscribe puts the oils on Trade selling plans and every diffuser in the package rides free
    (one per C.freeEvery subscribed oils); buy once takes the package percent off everyday prices
    through one code per package. Colours and scents are chosen at the package's fixed counts.
  - All money is in cents. Checkout follows aura-gift-builder: clear, add, apply code(s), assert
    every code is applicable, block a total above the page total, hold against late cart writes, go.
  - Free-kit and wholesale email builders.
*/
(function () {
  document.documentElement.classList.add('atr-js');
  var RM = false; try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) {}
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };
  function text(sel, t) { var el = $(sel); if (el && t != null) el.textContent = t; }

  var WORD = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
  function w(n) { return n < WORD.length ? WORD[n] : String(n); }
  function W(n) { var s = w(n); return s.charAt(0).toUpperCase() + s.slice(1); }
  function money(c) { var d = c / 100; return '$' + (c % 100 ? d.toFixed(2) : Math.round(d).toLocaleString('en-US')); }
  function hr(h) { return h === 12 ? '12pm' : h < 12 ? h + 'am' : (h - 12) + 'pm'; }

  // ---------- config ----------
  var C = null;
  try { var ce = document.getElementById('atr-config'); if (ce) C = JSON.parse(ce.textContent); } catch (e) { C = null; }

  // A partner code saved by a /discount/CODE link. Only codes listed in the builder settings count.
  function savedCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return '';
    var c = ''; try { c = decodeURIComponent(m[1]).trim().toUpperCase(); } catch (_) { return ''; }
    return C && C.partnerCodes && C.partnerCodes.indexOf(c) >= 0 ? c : '';
  }
  var CODE = savedCode();
  (function note() {
    var n = $('#atr-note-text');
    if (n && CODE && n.getAttribute('data-code-text')) n.textContent = n.getAttribute('data-code-text').replace('{code}', CODE);
  })();

  // ---------- spaces ----------
  var panels = $$('.atr-vertical'), tabs = $$('.atr-tab');
  var SP = {};
  panels.forEach(function (p) {
    var d = p.dataset;
    SP[p.id] = { name: d.name, noun: d.noun, enoun: d.enoun, room: d.room, days: d.days, on: +d.on || 9, off: +d.off || 19,
      lede: d.lede, why: d.why, type: d.type, start: d.setup || '1,6', oil: d.oil || 'collins', lead: d.lead };
  });
  var ALIAS = {};
  var spacesEl = $('#spaces');
  if (spacesEl) (spacesEl.getAttribute('data-aliases') || '').split(/\n/).forEach(function (l) {
    var p = l.split(':'); if (p.length > 1) ALIAS[p[0].trim().toLowerCase()] = p[1].trim().toLowerCase();
  });

  var eyebrow = $('#atr-hero-eyebrow'), heroLede = $('#atr-hero-lede'), noun = $('#atr-h-noun'), whyLine = $('#atr-why-line');
  function dflt(el) { return el ? el.getAttribute('data-default') : null; }
  function card(on, off, days, room) {
    text('#atr-card-days', days); text('#atr-card-room', room);
    text('#atr-card-on', hr(on) + ' on'); text('#atr-card-off', hr(off) + ' off');
    var b = $('#atr-card-bar'); if (b) { b.style.left = ((on - 6) / 16 * 100) + '%'; b.style.width = ((off - on) / 16 * 100) + '%'; }
  }

  // Packages are fixed (diffusers, oils per delivery, delivery months); default is the one-room package.
  var PKGS = [[1, 4, 1], [2, 8, 2], [3, 12, 3]];
  function pkgFor(d) { return d >= 3 ? 2 : d === 2 ? 1 : 0; }
  var st = { vertical: null, oil: 'collins', pack: 0, buy: (C && C.subLive) ? 'sub' : 'once', mode: 'set', own: {}, colors: {}, picked: false };
  function pk() { return PKGS[st.pack]; }

  function showVertical(id, scroll) {
    var s = SP[id]; if (!s) return;
    st.vertical = id;
    panels.forEach(function (p) { p.classList.toggle('atr-shown', p.id === id); });
    tabs.forEach(function (t) { var on = t.getAttribute('aria-controls') === id; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    var t = $('#atr-tab-' + id);
    if (t) { var row = t.parentNode; try { row.scrollTo({ left: t.offsetLeft - row.offsetLeft - 12, behavior: RM ? 'auto' : 'smooth' }); } catch (_) {} }
    if (eyebrow && eyebrow.getAttribute('data-for')) eyebrow.textContent = eyebrow.getAttribute('data-for').replace('{space}', s.name).replace('{noun}', s.enoun || s.noun || s.name);
    if (heroLede && s.lede) heroLede.textContent = s.lede;
    if (whyLine && s.why) whyLine.textContent = s.why;
    if (noun && s.noun) noun.textContent = s.noun;
    card(s.on, s.off, s.days, s.room);
    $$('[data-door]').forEach(function (d) { d.setAttribute('aria-current', d.getAttribute('data-door') === id ? 'true' : 'false'); });
    st.oil = s.oil === 'neutralizer' ? 'collins' : s.oil;
    if (!st.picked) { var sv = s.start.split(','); st.pack = pkgFor(+sv[0] || 1); st.mode = 'set'; }
    setType(s.type);
    if (scroll) { var p = document.getElementById(id); if (p) p.scrollIntoView({ block: 'start' }); }
    paint();
  }
  function resetHero() {
    if (eyebrow) eyebrow.textContent = dflt(eyebrow);
    if (heroLede) heroLede.textContent = dflt(heroLede);
    if (whyLine) whyLine.textContent = dflt(whyLine);
    if (noun) noun.textContent = dflt(noun);
    var first = panels[0] && SP[panels[0].id];
    if (first) card(first.on, first.off, first.days, first.room);
    $$('[data-door]').forEach(function (d) { d.setAttribute('aria-current', 'false'); });
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault(); var id = t.getAttribute('aria-controls');
      showVertical(id, false); try { history.replaceState(null, '', '#' + id); } catch (_) {}
    });
  });
  var tabRow = $('.atr-tabs');
  if (tabRow) tabRow.addEventListener('keydown', function (e) {
    var i = tabs.indexOf(document.activeElement); if (i < 0) return;
    var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null; if (n === null) return;
    e.preventDefault(); n = (n + tabs.length) % tabs.length; tabs[n].focus(); showVertical(tabs[n].getAttribute('aria-controls'), false);
  });
  // hero chips retune in place, no scroll
  $$('[data-door]').forEach(function (d) {
    var id = d.getAttribute('data-door'); if (!SP[id]) return;
    // No history entry: these personalise the hero in place and deliberately do not scroll, so a
    // hash here makes the back button collect states that look like navigation and are not. The
    // tabs below still set it, because those do move you to a panel.
    d.addEventListener('click', function (e) { e.preventDefault(); showVertical(id, false); });
  });

  // ---------- package builder ----------
  var B = !!(C && C.diff && C.oils && Object.keys(C.oils).length && $('#kits'));
  var COLORS = (C && C.colors) || [];
  var FIRST_COLOR = null;
  COLORS.forEach(function (c) { if (!FIRST_COLOR && c.avail) FIRST_COLOR = c; });
  var LEADLINE = { collins: 'Collins-led: our bestseller, with Coast and Manifest.', coast: 'Coast-led: fresh and breezy, with Collins and Manifest.', manifest: 'Manifest-led: warm and quiet, with Dubai and Collins.', dubai: 'Dubai-led: rich and warm, with Manifest and Collins.' };
  var ORDER = { collins: ['collins', 'coast', 'manifest', 'dubai'], coast: ['coast', 'collins', 'manifest', 'dubai'], manifest: ['manifest', 'dubai', 'collins', 'coast'], dubai: ['dubai', 'manifest', 'collins', 'coast'] };
  var WEIGHTS = [0.45, 0.25, 0.15, 0.15];
  var CADW = { 1: 'every month', 2: 'every two months', 3: 'every three months' };

  // One-time: the whole package at a percent off everyday prices, one code per package.
  // pack_pcts "1: 20, 2: 30, 3: 40"; pack_codes lines "1: TRADE-PACK20".
  var PCTS = {};
  String((C && C.packPcts) || '').split(',').forEach(function (p) { var q = p.split(':'); if (q.length === 2) PCTS[+q[0].trim()] = +q[1].trim(); });
  function packPct(d) { return PCTS[d] || C.pct; }
  function offPct(c, pct) { return Math.round(c * (100 - pct) / 100); }
  function packCode(d) {
    var best = null, bestN = -1;
    String((C && C.packCodes) || '').split(/\n/).forEach(function (l) { var i = l.indexOf(':'); if (i < 0) return; var k = +l.slice(0, i); if (k <= d && k > bestN) { bestN = k; best = l.slice(i + 1).trim().toUpperCase(); } });
    return best;
  }
  // Subscription price per bottle by bottles per delivery: 1-2, 3-5, 6-8, 9-11, 12+.
  var SUBP = String((C && C.subPrices) || '').split(',').map(function (x) { return Math.round(parseFloat(x) * 100); }).filter(function (x) { return x > 0; });
  function subUnit(n) { if (!SUBP.length) return 0; var i = n >= 12 ? 4 : n >= 9 ? 3 : n >= 6 ? 2 : n >= 3 ? 1 : 0; return SUBP[Math.min(i, SUBP.length - 1)]; }
  // Trade selling plans: lines of "oil, months, minimum oils, plan id" (oil = collins, coast ...).
  var PLANS = String((C && C.plans) || '').split(/\n/).map(function (l) { var p = l.split(',').map(function (x) { return x.trim(); }); return p.length === 4 ? { oil: p[0].toLowerCase(), cad: +p[1], min: +p[2], id: p[3] } : null; }).filter(Boolean);
  function planFor(k, o, cad) { var best = null; PLANS.forEach(function (p) { if (p.oil === k && p.cad === cad && p.min <= o && (!best || p.min > best.min)) best = p; }); return best && best.id; }
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim().toUpperCase(); }).filter(Boolean); }

  function split(keys, weights, n) {
    var raw = weights.map(function (x) { return x * n; }), base = raw.map(Math.floor), left = n - base.reduce(function (a, b) { return a + b; }, 0);
    raw.map(function (x, i) { return [x - Math.floor(x), i]; }).sort(function (a, b) { return b[0] - a[0]; }).slice(0, left).forEach(function (p) { base[p[1]]++; });
    var m = {}; keys.forEach(function (k, i) { if (base[i] && C.oils[k]) m[k] = (m[k] || 0) + base[i]; });
    var tot = 0; for (var k in m) tot += m[k];
    if (tot < n) { var lead = keys.filter(function (k) { return C.oils[k]; })[0]; if (lead) m[lead] = (m[lead] || 0) + n - tot; }
    return m;
  }
  function setMix() { return st.mode === 'own' ? st.own : split(ORDER[st.oil] || ORDER.collins, WEIGHTS, pk()[1]); }
  function mixTotal(m) { var t = 0; for (var k in m) t += m[k]; return t; }
  function colorTotal() { var t = 0; for (var k in st.colors) t += st.colors[k]; return t; }
  // Colours always sum to the package's diffusers; missing allocation falls to the first in-stock colour.
  function fitColors() {
    var d = pk()[0], t = colorTotal();
    if (t === d) return;
    if (t > d) { // shrink, largest first
      var keys = Object.keys(st.colors).sort(function (a, b) { return st.colors[b] - st.colors[a]; });
      var over = t - d;
      keys.forEach(function (k) { if (!over) return; var cut = Math.min(over, st.colors[k]); st.colors[k] -= cut; over -= cut; if (!st.colors[k]) delete st.colors[k]; });
    } else if (FIRST_COLOR) {
      st.colors[FIRST_COLOR.id] = (st.colors[FIRST_COLOR.id] || 0) + (d - t);
    }
  }

  var Q = null; // the quote for the current setup, used by checkout
  function quote() {
    var p = pk(), d = p[0], cad = p[2], m = setMix(), o = mixTotal(m), sub = st.buy === 'sub' && C.subLive;
    var ev = d * C.diff.price, oTot = 0, dTot = 0, free = 0, pct = packPct(d);
    for (var k in m) ev += m[k] * C.oils[k].price;
    if (sub) {
      free = Math.min(d, Math.floor(o / (C.freeEvery || 3)));
      for (var k2 in m) oTot += m[k2] * subUnit(o);
      dTot = (d - free) * offPct(C.diff.price, pct); // packages keep every diffuser free; belt and braces
    } else {
      dTot = d * offPct(C.diff.price, pct);
      for (var k3 in m) oTot += m[k3] * offPct(C.oils[k3].price, pct);
    }
    return { d: d, o: o, cad: cad, m: m, sub: sub, free: free, paid: sub ? d - free : d, pct: pct, dTot: dTot, oTot: oTot, tot: dTot + oTot, ev: ev };
  }
  // A package's first-delivery price both ways. sub is null while Trade subscriptions are not live.
  function basket(d, o) {
    var pct = packPct(d);
    var once = d * offPct(C.diff.price, pct) + o * offPct(C.baseOil, pct);
    if (!C.subLive) return { once: once, sub: null, free: 0 };
    var free = Math.min(d, Math.floor(o / (C.freeEvery || 3)));
    return { once: once, sub: (d - free) * offPct(C.diff.price, pct) + o * subUnit(o), free: free };
  }
  function leadName() {
    var sv = st.vertical && SP[st.vertical], line = (sv && sv.lead) || LEADLINE[st.oil] || LEADLINE.collins;
    return line.split(':')[0].replace(/,.*/, '');
  }

  function freeBox(d, o, b) {
    var ship = C.freeShipOver > 0 && Math.min(b.once, b.sub === null ? b.once : b.sub) >= C.freeShipOver;
    var h = '<span class="atr-free-h">Included free when you subscribe</span><ul>';
    h += '<li><span>' + W(d) + ' diffuser' + (d > 1 ? 's' : '') + '</span><span><s>' + money(d * C.diff.price) + '</s> Free</span></li>';
    h += '<li><span>Scent trade-ins within 30 days</span><span>Free</span></li>';
    if (ship) h += '<li><span>Shipping</span><span>Free</span></li>';
    return h + '</ul>';
  }
  function paintSets() {
    var lead = leadName();
    $$('.atr-set').forEach(function (c, i) {
      var v = c.getAttribute('data-set').split(','), d = +v[0], o = +v[1], cad = +v[2] || 1;
      var b = basket(d, o), hasSub = b.sub !== null;
      // Show the mode the viewer actually picked, not whichever one exists. Reading the subscribe
      // price, "43% off your first delivery" and a free-diffuser box while Buy once is selected and
      // charges a different number is the kind of mismatch nobody forgives at checkout.
      var sub = hasSub && st.buy === 'sub';
      var f = function (k) { return c.querySelector('[data-f="' + k + '"]'); };
      var main = sub ? b.sub : b.once, ev = d * C.diff.price + o * C.baseOil, save = ev - main;
      f('price').textContent = money(main);
      f('was').textContent = money(ev);
      f('save').textContent = 'Save ' + money(save);
      f('pct').textContent = Math.round(save / ev * 100) + '% off' + (sub ? ' your first delivery' : '');
      // Shown in both modes on purpose: the heading says "when you subscribe", so it reads as what
      // subscribing would get you rather than a claim about the basket you have selected. Hiding it
      // on Buy once threw away the best argument for the mode we would rather they pick.
      f('free').innerHTML = hasSub ? freeBox(d, o, b) : '';
      // the markup ships this hardcoded to a subscription cadence; a one-time order has none
      var cadEl = f('cad');
      if (cadEl) cadEl.textContent = sub ? CADW[cad] : 'one time';
      var gs = f('gosub'), go = f('goonce');
      if (hasSub) { gs.hidden = false; gs.textContent = 'Subscribe · ' + money(b.sub) + ' a delivery'; }
      else gs.hidden = true;
      go.textContent = 'Buy once · ' + money(b.once) + ' (' + packPct(d) + '% off)';
      var onCard = st.pack === i;
      c.classList.toggle('atr-on', onCard);
      gs.setAttribute('aria-pressed', onCard && st.buy === 'sub' ? 'true' : 'false');
      go.setAttribute('aria-pressed', onCard && st.buy === 'once' ? 'true' : 'false');
    });
    var fromEl = $('#atr-from');
    if (fromEl) {
      var b1 = basket(PKGS[0][0], PKGS[0][1]), b3 = basket(PKGS[2][0], PKGS[2][1]);
      var ev3 = PKGS[2][0] * C.diff.price + PKGS[2][1] * C.baseOil;
      var low = b1.sub === null ? b1.once : Math.min(b1.sub, b1.once);
      var big = b3.sub === null ? b3.once : Math.min(b3.sub, b3.once);
      fromEl.textContent = 'From ' + money(low) + '. Save up to ' + Math.round((ev3 - big) / ev3 * 100) + '% against everyday prices.';
      fromEl.hidden = false;
    }
  }

  function paintColors() {
    var wrap = $('#atr-colors'); if (!wrap) return;
    var d = pk()[0];
    fitColors();
    wrap.innerHTML = '';
    COLORS.forEach(function (col, idx) {
      var n = st.colors[col.id] || 0;
      var el = document.createElement('div');
      el.className = 'atr-color' + (col.avail ? '' : ' is-soldout') + (n ? ' atr-on' : '');
      el.setAttribute('data-color', col.id);
      // The card itself is a button so colours work from the keyboard; the stepper (multi-diffuser
      // packs) sits outside it, since buttons cannot nest.
      var inner = (col.img ? '<img src="' + col.img + '" alt="" loading="lazy" decoding="async" width="250" height="250">' : '') +
        '<span class="atr-color-name"><span class="atr-swatch" aria-hidden="true"></span><span class="atr-color-t"></span>' + (idx === 0 ? '<span class="atr-tagpop">Bestseller</span>' : '') + '</span>';
      el.innerHTML = (col.avail
        ? '<button type="button" class="atr-color-card">' + inner + '</button>' +
          (d > 1 ? '<span class="atr-stepper"><button type="button" data-cd="-1" aria-label="One fewer ' + col.title + '">&minus;</button><output>' + n + '</output><button type="button" data-cd="1" aria-label="One more ' + col.title + '">+</button></span>' : '')
        : '<span class="atr-color-card">' + inner + '<span class="atr-color-flag">Sold out</span></span>');
      el.querySelector('.atr-color-t').textContent = col.title;
      if (col.avail) {
        var cardBtn = el.querySelector('.atr-color-card');
        cardBtn.setAttribute('aria-label', (d === 1 ? 'Choose ' : 'One more diffuser in ') + col.title);
        cardBtn.setAttribute('aria-pressed', n ? 'true' : 'false');
        cardBtn.addEventListener('click', function () {
          if (d === 1) { st.colors = {}; st.colors[col.id] = 1; }
          else if (colorTotal() < d) st.colors[col.id] = (st.colors[col.id] || 0) + 1;
          st.picked = true; paint();
        });
      }
      $$('button[data-cd]', el).forEach(function (b) {
        var dl = +b.getAttribute('data-cd');
        b.disabled = (dl > 0 && colorTotal() >= d) || (dl < 0 && !n);
        b.addEventListener('click', function () {
          var cur = st.colors[col.id] || 0, next = Math.max(0, cur + dl);
          if (dl > 0 && colorTotal() >= d) return;
          if (next) st.colors[col.id] = next; else delete st.colors[col.id];
          st.picked = true; paint();
        });
      });
      wrap.appendChild(el);
    });
    var names = [];
    COLORS.forEach(function (col) { var n = st.colors[col.id] || 0; if (n) names.push(d > 1 ? n + ' ' + col.title.toLowerCase() : col.title.toUpperCase() + ' SELECTED'); });
    text('#atr-color-opt', d > 1 ? names.join(' · ').toUpperCase() : (names[0] || ''));
    text('#atr-color-hint', d > 1 ? 'One colour per diffuser: ' + w(d) + ' to place.' : '');
  }

  function paint() {
    if (!B) return;
    var q = quote(); Q = q;
    var d = q.d, o = q.o, m = q.m, sub = q.sub, cad = q.cad;
    $$('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mode') === st.mode ? 'true' : 'false'); });
    paintSets();
    paintColors();

    // scents
    var ul = $('#atr-mix'), keys = st.mode === 'own' ? Object.keys(C.oils) : Object.keys(m);
    var need = pk()[1], chosen = st.mode === 'own' ? mixTotal(st.own) : need;
    var bar = $('#atr-count');
    if (bar) { bar.hidden = st.mode !== 'own'; text('#atr-count-n', chosen); text('#atr-count-need', need); }
    if (ul) {
      ul.innerHTML = '';
      keys.forEach(function (k) {
        var n = m[k] || 0; if (st.mode !== 'own' && !n) return; if (!C.oils[k]) return;
        var li = document.createElement('li'), nm = C.oils[k].name;
        li.innerHTML = '<img src="' + C.oils[k].img + '" alt="" width="48" height="48" loading="lazy" decoding="async">' +
          '<span class="atr-nm"><span class="atr-nm-t"></span><span class="atr-nm-c"></span></span>' +
          (st.mode === 'own'
            ? '<span class="atr-stepper"><button type="button" data-d="-1">&minus;</button><output>' + n + '</output><button type="button" data-d="1">+</button></span>'
            : '<span class="atr-inc">&times;' + n + ' · Included</span>');
        var tEl = li.querySelector('.atr-nm-t'); tEl.textContent = nm;
        var sm = document.createElement('small'); sm.textContent = k === 'neutralizer' ? 'Also available' : 'Bestseller'; tEl.appendChild(sm);
        li.querySelector('.atr-nm-c').textContent = C.oils[k].notes || '';
        li.setAttribute('data-k', k);
        $$('button', li).forEach(function (b) { b.setAttribute('aria-label', (b.getAttribute('data-d') === '1' ? 'One more ' : 'One fewer ') + nm); });
        ul.appendChild(li);
      });
      if (st.mode === 'own') $$('button', ul).forEach(function (b) {
        var k = b.parentNode.parentNode.getAttribute('data-k'), dl2 = +b.getAttribute('data-d');
        b.disabled = (dl2 < 0 && !(st.own[k] > 0)) || (dl2 > 0 && chosen >= need);
        b.addEventListener('click', function () {
          if (dl2 > 0 && mixTotal(st.own) >= need) return;
          st.own[k] = (st.own[k] || 0) + dl2; if (st.own[k] <= 0) delete st.own[k];
          st.picked = true; paint();
        });
      });
    }
    var sv = st.vertical && SP[st.vertical];
    text('#atr-mix-line', st.mode === 'own' ? 'Any mix of our bestsellers, or The Neutralizer if you prefer it, at your package\'s ' + w(need) + ' bottles.' : ((sv && sv.lead) || LEADLINE[st.oil] || LEADLINE.collins));
    text('#atr-scent-opt', st.mode === 'own' ? (chosen === need ? 'YOUR MIX' : chosen + ' OF ' + need + ' CHOSEN') : 'CURATED SELECTED');

    // summary
    var everyday = money(C.diff.price);
    text('#atr-t-mode', sub ? 'Subscription' : 'One-time');
    text('#atr-t-sum-l', sub ? 'Per delivery' : 'Total');
    var html = '', colorNames = [];
    COLORS.forEach(function (col) { var n = st.colors[col.id] || 0; if (n) colorNames.push((d > 1 ? n + ' ' : '') + col.title.toLowerCase()); });
    var dLabel = W(d) + ' diffuser' + (d > 1 ? 's' : '') + (colorNames.length ? ' (' + colorNames.join(', ') + ')' : '');
    if (sub) {
      html += '<div><dt>' + dLabel + '</dt><dd>Free</dd><small>Everyday ' + everyday + (d > 1 ? ' each' : '') + ', free with your subscription</small></div>';
      html += '<div><dt>' + W(o) + ' fragrance oils, 30 mL, ' + CADW[cad] + '</dt><dd>' + money(q.oTot) + '</dd><small>' + money(subUnit(o)) + ' each, everyday ' + money(C.baseOil) + '</small></div>';
    } else {
      html += '<div><dt>' + dLabel + '</dt><dd>' + money(q.dTot) + '</dd><small>' + money(offPct(C.diff.price, q.pct)) + (d > 1 ? ' each' : '') + ', everyday ' + everyday + '</small></div>';
      html += '<div><dt>' + W(o) + ' fragrance oils, 30 mL</dt><dd>' + money(q.oTot) + '</dd><small>' + money(offPct(C.baseOil, q.pct)) + ' each, everyday ' + money(C.baseOil) + '</small></div>';
    }
    if (C.freeShipOver > 0 && q.tot >= C.freeShipOver) html += '<div><dt>Shipping</dt><dd>Free</dd></div>';
    var tl = $('#atr-t-lines'); if (tl) tl.innerHTML = html;
    text('#atr-t-total', money(q.tot));
    var save = $('#atr-t-save');
    if (save) { save.hidden = q.ev - q.tot <= 0; save.textContent = 'Save ' + money(q.ev - q.tot) + ' vs everyday prices' + (sub ? ' on your first delivery' : ' (' + q.pct + '% off)'); }
    // On a one-time basket, name what switching would be worth. basket() is the same function the
    // package cards price their own two buttons with, so this number always agrees with them.
    var up = $('#atr-t-upsell');
    if (up) {
      var alt = basket(q.d, q.o), extra = (!sub && alt.sub !== null) ? q.tot - alt.sub : 0;
      up.hidden = extra <= 0;
      if (extra > 0) {
        up.textContent = 'Save another ' + money(extra) + ' a delivery when you subscribe, with '
          + (alt.free === 1 ? 'the diffuser' : W(alt.free).toLowerCase() + ' diffusers') + ' free. No commitment.';
      }
    }
    var note;
    if (sub) note = 'Then ' + money(q.oTot) + ' ' + CADW[cad] + (cad > 1 ? ', about ' + money(Math.round(q.oTot / cad)) + ' a month.' : '.');
    else if (d === 1 && CODE) note = 'Your partner code ' + CODE + ' is applied at checkout.';
    else note = 'Package pricing is applied at checkout. Nothing renews.';
    text('#atr-t-note', note);
    var terms = $('#atr-t-terms'); if (terms) terms.hidden = !sub;

    var ready = chosen === need && colorTotal() === d, go = $('#atr-t-go'), sg = $('#atr-sticky-go');
    if (go) { go.disabled = !ready || busy; go.textContent = sub ? 'Start subscription · ' + money(q.tot) : 'Checkout · ' + money(q.tot); }
    var names = { 0: 'One room', 1: 'A large room, or two rooms', 2: 'Three rooms, or a whole floor' };
    if (st.picked && ready) {
      text('#atr-sticky-label', names[st.pack] + ' · ' + (sub ? 'Subscribe' : 'One-time'));
      text('#atr-sticky-total', money(q.tot) + (sub ? ' a delivery' : '') + (q.ev > q.tot ? ' · save ' + money(q.ev - q.tot) : ''));
      if (sg) { sg.textContent = sub ? 'Subscribe' : 'Checkout'; sg.setAttribute('data-checkout', ''); }
    } else {
      text('#atr-sticky-label', sv ? 'Aura for your ' + (sv.enoun || sv.noun || 'business') : 'Aura for your business');
      text('#atr-sticky-total', names[st.pack] + ': ' + money(q.tot) + (sub ? ' a delivery, diffuser' + (d > 1 ? 's' : '') + ' free' : ' once'));
      if (sg) { sg.textContent = 'Choose setup'; sg.removeAttribute('data-checkout'); }
    }
    stickyBar && stickyBar();
  }

  var stickyBar = null, busy = false;
  if (B) {
    if (FIRST_COLOR) st.colors[FIRST_COLOR.id] = pk()[0];
    $$('[data-mode]').forEach(function (b) { b.addEventListener('click', function () { var md = b.getAttribute('data-mode'); if (md === 'own' && st.mode !== 'own') st.own = setMix(); st.mode = md; st.picked = true; paint(); }); });
    var clearBtn = $('#atr-count-clear'); if (clearBtn) clearBtn.addEventListener('click', function () { st.own = {}; paint(); });
    $$('.atr-set').forEach(function (c, i) {
      $$('[data-pick-buy]', c).forEach(function (b) {
        b.addEventListener('click', function () {
          st.pack = i; st.buy = b.getAttribute('data-pick-buy');
          if (st.buy === 'sub' && !C.subLive) st.buy = 'once';
          if (st.mode === 'own') st.own = {}; // counts changed; start the custom mix over
          if (st.mode === 'own' && !Object.keys(st.own).length) st.own = split(ORDER[st.oil] || ORDER.collins, WEIGHTS, pk()[1]);
          st.picked = true; fitColors(); paint();
          var cp = $('#atr-colors-panel'); if (cp) cp.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' });
        });
      });
    });
    if (C.subLive) $$('[data-sub-only]').forEach(function (el) { el.hidden = false; });

    // sticky bar: appears once the hero button is off screen, or as soon as a setup is chosen
    var sticky = $('#atr-sticky'), heroBtn = $('#atr-hero-shop'), heroGone = !heroBtn;
    stickyBar = function () { if (sticky) sticky.classList.toggle('atr-show', heroGone || !!st.picked); };
    if (heroBtn && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; stickyBar(); }).observe(heroBtn);
    else heroGone = true;
    var sg = $('#atr-sticky-go');
    if (sg) sg.addEventListener('click', function (e) { if (sg.hasAttribute('data-checkout')) { e.preventDefault(); checkout(); } });
    var goBtn = $('#atr-t-go'); if (goBtn) goBtn.addEventListener('click', checkout);

    // Shoppers with items already in the cart are told the setup checks out on its own.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { var n = $('#atr-t-cart'); if (n && c && c.item_count > 0) n.hidden = false; }).catch(function () {});
  }

  // ---------- checkout (money path from aura-gift-builder) ----------
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function jsonOrThrow(r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || ('HTTP ' + r.status)); return j; }); }
  function fail(msg, cartLink) {
    var e = $('#atr-t-err'); busy = false; paint();
    if (!e) return;
    e.textContent = msg;
    if (cartLink) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = ' Review your cart'; e.appendChild(a); }
    e.hidden = false;
  }
  function checkout() {
    if (!B || busy) return;
    var q = quote();
    if (q.o !== pk()[1] || colorTotal() !== q.d) return;
    var err = $('#atr-t-err'); if (err) err.hidden = true;
    var sub = q.sub, items = [], codes = [];
    // Every diffuser in a subscribed package must ride free (the BXGY covers one per freeEvery
    // oils). A paid diffuser alongside a subscription has no priced path; refuse it outright.
    if (sub && q.free < q.d) {
      return fail('With a subscription, we can include one free diffuser per ' + (C.freeEvery || 3) + ' bottles. This package should cover its diffusers; please re-choose it, or email ' + C.email + ' and we\'ll sort it.');
    }
    // _trade marks every line as a Trade setup line (hidden at checkout), so a discount Function can key on it.
    var props = { _trade: sub ? 'subscribe' : 'once' };
    COLORS.forEach(function (col) { var n = st.colors[col.id] || 0; if (n) items.push({ id: col.id, quantity: n, properties: props }); });
    var missing = false;
    Object.keys(q.m).forEach(function (k) {
      if (!q.m[k]) return;
      var it = { id: C.oils[k].id, quantity: q.m[k], properties: props };
      if (sub) { var plan = planFor(k, q.o, q.cad); if (!plan) missing = true; it.selling_plan = +plan; }
      items.push(it);
    });
    if (missing) return fail('This delivery option isn\'t available yet. Please choose another, or email ' + C.email + '.');
    if (sub) { if (q.free) codes = list(C.subCodes); }
    else codes = (q.d === 1 && CODE) ? [CODE] : [packCode(q.d)].filter(Boolean);
    var label = (sub ? 'Subscribe ' + CADW[q.cad] + ': ' : 'One-time: ') + q.d + ' diffuser' + (q.d === 1 ? '' : 's') + ' + ' + q.o + ' oils';
    var attrs = { 'Trade order': 'Yes', 'Trade setup': label };
    if (st.vertical) attrs['Trade space'] = st.vertical;
    if (CODE) attrs['Partner code'] = CODE; // keeps the partner's attribution when a package code replaces their code

    // The page's own codes replace whatever an earlier /discount/ link saved; checkout would re-apply it.
    if (!(codes.length === 1 && codes[0] === CODE)) {
      document.cookie = 'discount_code=; Max-Age=0; path=/';
      document.cookie = 'discount_code=; Max-Age=0; path=/; domain=.' + location.hostname.replace(/^www\./, '');
    }
    function applyCodeAndNotes() {
      return fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ attributes: attrs, discount: codes.join(',') }) }).then(jsonOrThrow);
    }
    function codesOn(cart) {
      var on = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return String(d.code).toUpperCase(); });
      return codes.every(function (c) { return on.indexOf(c) >= 0; });
    }
    function notesOn(cart) { var a = cart.attributes || {}; return Object.keys(attrs).every(function (k) { return a[k] === attrs[k]; }); }
    // Block only an overcharge vs the page. A lower total means another discount helped the buyer.
    function priceOk(cart) { return !(cart.currency === 'USD' && cart.total_price > q.tot); }
    var SETTLE_MIN = 1500, QUIET = 900, SETTLE_MAX = 6000;
    var CART_WRITE = /\/cart\/(update|change|add|clear)\.js|\/api\/[^\/]+\/graphql\.json/;
    function settle() {
      var start = performance.now();
      return new Promise(function (done) {
        (function tick() {
          var now = performance.now(), last = start;
          performance.getEntriesByType('resource').forEach(function (e) { if (CART_WRITE.test(e.name) && e.responseEnd > last) last = e.responseEnd; });
          if ((now - start >= SETTLE_MIN && now - last >= QUIET) || now - start >= SETTLE_MAX) return done();
          setTimeout(tick, 150);
        })();
      });
    }
    function readCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(jsonOrThrow); }
    var HOLD_FAILED = 'hold-failed';
    function hold(attempt) {
      return settle().then(readCart).then(function (cart) {
        if (codesOn(cart) && notesOn(cart) && priceOk(cart)) return cart;
        if (attempt >= 2) throw new Error(HOLD_FAILED);
        return applyCodeAndNotes().then(function () { return hold(attempt + 1); });
      });
    }
    busy = true; paint();
    var goBtn = $('#atr-t-go'); if (goBtn) goBtn.textContent = 'Adding your setup';
    fetch('/cart/clear.js', { method: 'POST', headers: JSON_HEADERS }).then(jsonOrThrow)
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: items }) }).then(jsonOrThrow); })
      .then(applyCodeAndNotes)
      .then(function (cart) {
        if (!codesOn(cart)) throw new Error('the package price could not be applied');
        if (!priceOk(cart)) throw new Error('the cart total ' + money(cart.total_price) + ' did not match ' + money(q.tot));
        return hold(0);
      })
      .then(function (cart) {
        if (window.dataLayer) window.dataLayer.push({ event: 'trade_builder_checkout', trade_mode: sub ? 'subscribe' : 'once', trade_diffusers: q.d, trade_oils: q.o, trade_space: st.vertical || '', trade_value: cart.total_price / 100, currency: cart.currency });
        window.location.href = '/checkout' + (codes.length ? '?discount=' + encodeURIComponent(codes.join(',')) : '');
      })
      .catch(function (e) {
        if (e.message === HOLD_FAILED) fail('We couldn\'t hold your package price on the cart, so we haven\'t sent you to checkout at a higher price. Please try again in a moment. Your setup is in your cart.', true);
        else fail('Something went wrong adding your setup (' + e.message + '). Please try again, or email ' + C.email + '.');
      });
  }

  // ---------- free-kit and wholesale email builders ----------
  var kit = $('#atr-kit-form'), status = $('#atr-status');
  var f = { name: $('#atr-f-name'), type: $('#atr-f-type'), size: $('#atr-f-size'), city: $('#atr-f-city') };
  function setType(t) { if (!t || !f.type) return; for (var i = 0; i < f.type.options.length; i++) { if (f.type.options[i].text === t) f.type.selectedIndex = i; } build(); }
  function build() {
    if (!kit) return;
    var to = kit.getAttribute('data-email'), n = f.name.value.trim() || '[your business name]', c = f.city.value.trim();
    var subject = 'Free kit request: ' + n;
    var body = 'Hi Leif,\n\nI run ' + n + (c ? ' in ' + c : '') + '. It\'s a ' + f.type.value.toLowerCase() + ', roughly ' + f.size.value.toLowerCase() + '.\n\nI\'d like to try a free diffuser in the space. Here\'s the best way to reach me:\n\n[name and phone]\n\nThanks';
    $('#atr-f-msg').value = 'Subject: ' + subject + '\n\n' + body;
    $('#atr-mailto').href = 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }
  if (kit) { ['input', 'change'].forEach(function (ev) { Object.keys(f).forEach(function (k) { f[k].addEventListener(ev, build); }); }); build(); }
  var wsf = $('#atr-ws-form'), ws = { name: $('#atr-ws-name'), locs: $('#atr-ws-locs') };
  function wsBuild() {
    if (!wsf) return;
    var to = wsf.getAttribute('data-email'), n = ws.name.value.trim() || '[your business name]', subject = 'Wholesale inquiry: ' + n;
    var body = 'Hi,\n\nI\'m with ' + n + '. We\'re interested in Aura for ' + ws.locs.value.toLowerCase() + '.\n\nCould you send over how wholesale works? The best way to reach me:\n\n[name and phone]\n\nThanks';
    $('#atr-ws-msg').value = 'Subject: ' + subject + '\n\n' + body;
    $('#atr-ws-mailto').href = 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }
  if (wsf) { ['input', 'change'].forEach(function (ev) { ws.name.addEventListener(ev, wsBuild); ws.locs.addEventListener(ev, wsBuild); }); wsBuild(); }
  $$('[data-pick]').forEach(function (b) { b.addEventListener('click', function () { setType(b.getAttribute('data-pick')); }); });
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var el = document.getElementById(b.getAttribute('data-copy')); if (!el) return;
      var t = el.value !== undefined ? el.value : el.textContent;
      var form = b.closest('form'), stEl = (form && form.querySelector('.atr-status')) || status;
      var to = (form && form.getAttribute('data-email')) || (kit && kit.getAttribute('data-email')) || '';
      function ok() { var o = b.textContent; b.textContent = 'Copied'; if (stEl) stEl.textContent = /msg$/.test(b.getAttribute('data-copy')) ? 'Email copied. Paste it into a new message to ' + to + '.' : ''; setTimeout(function () { b.textContent = o; }, 1800); }
      function fallback() { try { if (el.select) el.select(); else { var r = document.createRange(); r.selectNodeContents(el); var s = getSelection(); s.removeAllRanges(); s.addRange(r); } if (stEl) stEl.textContent = 'Selected. Press copy on your keyboard.'; } catch (_) {} }
      try { navigator.clipboard.writeText(t).then(ok, fallback); } catch (_) { fallback(); }
    });
  });

  // ---------- deep links: #salons, #groomers ... open that space and personalize the page ----------
  function fromHash(scroll) { var h = (location.hash || '').slice(1).toLowerCase(); h = ALIAS[h] || h; if (SP[h]) showVertical(h, scroll); }
  window.addEventListener('hashchange', function () { fromHash(true); });
  var h0 = (location.hash || '').slice(1).toLowerCase();
  if (SP[ALIAS[h0] || h0]) {
    fromHash(false);
    try { history.scrollRestoration = 'manual'; } catch (_) {}
    window.scrollTo(0, 0); setTimeout(function () { window.scrollTo(0, 0); }, 60);
  } else if (panels.length) {
    showVertical(panels[0].id, false); st.vertical = null; resetHero(); st.oil = 'collins'; paint();
  } else paint();
})();
